import React from 'react';

/**
 * Maps panel content.
 * Used when path-map-left-sidebar "Maps" button is active.
 */
export default function MapsPanelContent({
  segments = [],
  activeSegmentIndex = 0,
  segmentColors = [],
  segmentVisibility = [],
  onToggleSegmentVisibility,
  onSelectSegment,
  onGoToSegment,
}) {
  const getSegmentLabel = (seg, idx) => {
    if (seg?.entityType === 'lane' || seg?.type === 'lane') return seg?.label || `Lane ${idx + 1}`;
    if (seg?.entityType === 'path' || seg?.type === 'path') return seg?.label || `Route${idx + 1}`;
    return seg?.label || `Route${idx + 1}`;
  };

  const visibleRows = (segments || [])
    .map((seg, idx) => ({ seg, idx }))
    .filter(
      ({ seg }) =>
        (seg?.entityType === 'lane' || seg?.type === 'lane' || seg?.entityType === 'path' || seg?.type === 'path') &&
        Array.isArray(seg?.pathData?.geometry?.coordinates) &&
        seg.pathData.geometry.coordinates.length >= 2
    );

  return (
    <div className="paths-panel-mode-content">
      <p></p>
      {visibleRows.length === 0 ? (
        <p>No paths or lanes created yet.</p>
      ) : (
        <div className="maps-panel-segments-list">
          {visibleRows.map(({ seg, idx }) => {
            const color = segmentColors[(seg.colorIndex ?? idx) % segmentColors.length];
            const label = getSegmentLabel(seg, idx);
            const visible = segmentVisibility[idx] !== false;
            return (
              <div key={`maps-segment-${idx}`} className="paths-panel-waypoints-header maps-panel-segment-row-header">
                <div
                  className={`paths-panel-waypoints-header-toggle paths-panel-maps-main-path-toggle maps-panel-segment-row ${idx === activeSegmentIndex ? 'paths-panel-waypoints-header-toggle-active' : ''}`}
                  aria-label={label}
                >
                  <div className="paths-panel-waypoints-header-toggle-content">
                    <div className="paths-panel-waypoints-header-toggle-top">
                      <button
                        type="button"
                        className="maps-panel-segment-title-select"
                        onClick={() => onSelectSegment?.(idx)}
                        title={seg?.entityType === 'lane' || seg?.type === 'lane' ? 'Select lane' : 'Select path'}
                        aria-label={`Select ${label}`}
                      >
                        <span className="paths-panel-waypoints-title">{label}</span>
                      </button>
                      {onGoToSegment && (
                        <span
                          role="button"
                          tabIndex={0}
                          className="paths-panel-waypoints-goto-btn"
                          onClick={(e) => {
                            e.stopPropagation();
                            onGoToSegment(idx);
                          }}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                              e.preventDefault();
                              e.stopPropagation();
                              onGoToSegment(idx);
                            }
                          }}
                          title={seg?.entityType === 'lane' || seg?.type === 'lane' ? 'Go to lane on map' : 'Go to path on map'}
                          aria-label={seg?.entityType === 'lane' || seg?.type === 'lane' ? 'Go to lane on map' : 'Go to path on map'}
                        >
                          <i className="fa-solid fa-location-crosshairs" aria-hidden />
                        </span>
                      )}
                      <button
                        type="button"
                        className="paths-panel-waypoints-eye-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          onToggleSegmentVisibility?.(idx);
                        }}
                        title={visible
                          ? (seg?.entityType === 'lane' || seg?.type === 'lane' ? 'Hide lane on map' : 'Hide path on map')
                          : (seg?.entityType === 'lane' || seg?.type === 'lane' ? 'Show lane on map' : 'Show path on map')}
                        aria-label={visible
                          ? (seg?.entityType === 'lane' || seg?.type === 'lane' ? 'Hide lane on map' : 'Hide path on map')
                          : (seg?.entityType === 'lane' || seg?.type === 'lane' ? 'Show lane on map' : 'Show path on map')}
                      >
                        <i className={`fas ${visible ? 'fa-eye' : 'fa-eye-slash'}`} aria-hidden />
                      </button>
                      <i
                        className="fa-solid fa-location-dot paths-panel-waypoints-header-toggle-dot"
                        style={{ color }}
                        title={seg?.entityType === 'lane' || seg?.type === 'lane' ? 'Lane color on map' : 'Path color on map'}
                        aria-hidden
                      />
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
